<template>
  <div>
    <div class="well text-center team-name" id="teamAName">{{ team.name }}</div>
    <div class="well text-center team-A-control" id="teamAControl">
      <button
        class="btn btn-lg btn-success w-100 mB-20 team-button"
        @click="goal($event, 1)"
      >
        Goal
      </button>
      <button
        class="btn btn-lg btn-primary w-100 mB-20 team-button"
        @click="damage(0, $event)"
      >
        {{
          damages[0].seconds
            | damageTimerText(
              damages[0].isActive,
              game.time_of_damage,
              "Damage " + (robotsNumber + 1)
            )
        }}
      </button>
      <button
        class="btn btn-lg btn-primary w-100 mB-20 team-button"
        @click="damage(1, $event)"
      >
        {{
          damages[1].seconds
            | damageTimerText(
              damages[1].isActive,
              game.time_of_damage,
              "Damage " + (robotsNumber + 2)
            )
        }}
      </button>
      <button
        class="btn btn-lg btn-danger w-100 mB-20 not-confirm team-button"
        @click="goal($event, -1)"
      >
        Goal -1
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["team", "game", "robotsNumber"],
  data() {
    return {
      damages: [
        {
          isActive: false,
          seconds: 0,
          interval: null,
        },
        {
          isActive: false,
          seconds: 0,
          interval: null,
        },
      ],
    };
  },
  mounted() {
    if (this.team.damages) {
      this.team.damages.forEach((damage, j) => {
        if (damage.isActive) {
          this.damages[j].isActive = false;
          this.damages[j].seconds = damage.seconds;
          this.damage(j);
        }
      });
    }
  },
  methods: {
    goal(event, change) {
      this.$parent.$options.methods.blink(event.target);
      this.$emit("goal", change);
    },
    damage(damage_index, event = null) {
      if (!this.damages[damage_index].isActive) {
        this.damages[damage_index].isActive = true;
        var timer = this.damages[damage_index];
        this.damages[damage_index].interval = setInterval(() => {
          if (this.game.isActive) {
            timer.seconds++;
            if (timer.seconds == this.game.time_of_damage) {
              timer.isActive = false;
              timer.seconds = 0;
              clearInterval(timer.interval);
              if (event) this.$parent.$options.methods.blink(event.target);
            }
          }
        }, 1000);
      } else {
        this.damages[damage_index].isActive = false;
        this.damages[damage_index].seconds = 0;
        clearInterval(this.damages[damage_index].interval);
      }
    },
    kickoff() {
      this.damages.forEach((damage) => {
        damage.isActive = false;
        damage.seconds = 0;
        clearInterval(damage.interval);
      });
    },
  },
  filters: {
    damageTimerText(seconds, isActive, time_of_damage, timerName) {
      if (isActive) return time_of_damage - seconds + "'";
      else return timerName;
    },
  },
};
</script>